// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Ionic
import { IonicModule } from '@ionic/angular';

// Internal dependencies
import { IconToggle } from './icon-toggle.component';


@NgModule({
  declarations: [
    IconToggle,
  ],
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [
    IconToggle,
  ],
})
export class IconToggleModule {}
